import React from "react";
import "./formBuilderPanelView.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";

interface IFormBuilderPanelViewHeader {
  heading: string;
  onBack?: () => void;
}

interface IFormBuilderPanelViewProps {
  header: IFormBuilderPanelViewHeader;
  children: JSX.Element;
}

export function FormBuilderPanelView(props: IFormBuilderPanelViewProps) {
  const { header, children } = props;

  return (
    <div className="form-builder-panel-view">
      <div className="panel-header">
        <div
          className="panel-heading"
          style={{
            cursor: header.onBack && "pointer",
          }}
          onClick={() => {
            if (header.onBack) {
              header.onBack();
            }
          }}
        >
          {header.onBack && <FontAwesomeIcon icon={faArrowLeft} />}
          {header.heading}
        </div>
      </div>

      <div className="panel-content">
        {children}
      </div>
    </div>
  );
}